"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _ToggleSwitch = require("./ToggleSwitch.styled");
var _UncontrolledTooltip = require("../UncontrolledTooltip");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ToggleSwitch = function ToggleSwitch(_ref) {
  var tooltipId = _ref.tooltipId,
    checked = _ref.checked,
    onClick = _ref.onClick,
    label = _ref.label,
    toolTipMessage = _ref.toolTipMessage,
    textSize = _ref.textSize,
    parentId = _ref.parentId,
    enableFeature = _ref.enableFeature,
    labelCursor = _ref.labelCursor,
    color = _ref.color,
    ddActionName = _ref.ddActionName;
  var onToggleClick = enableFeature ? onClick : function () {};
  return _react["default"].createElement(_ToggleSwitch.StyledCol, {
    className: "text-end",
    id: parentId
  }, _react["default"].createElement(_ToggleSwitch.StyledToggleSwitch, {
    on: checked,
    onClick: onToggleClick,
    enableFeature: enableFeature,
    ddActionName: ddActionName
  }), label && _react["default"].createElement(_ToggleSwitch.StyledText, {
    id: "tooltip-".concat(tooltipId),
    textSize: textSize,
    enableFeature: enableFeature,
    labelCursor: labelCursor,
    color: color
  }, label), toolTipMessage && enableFeature && _react["default"].createElement(_UncontrolledTooltip.StyledUncontrolledTooltip, {
    placement: "bottom",
    target: "tooltip-".concat(tooltipId)
  }, toolTipMessage));
};
ToggleSwitch.propTypes = {
  tooltipId: _propTypes.string,
  onClick: _propTypes.func,
  checked: _propTypes.bool,
  label: _propTypes.string,
  toolTipMessage: _propTypes.string,
  textSize: _propTypes.number,
  parentId: _propTypes.string,
  enableFeature: _propTypes.bool,
  labelCursor: _propTypes.string,
  color: _propTypes.string,
  ddActionName: _propTypes.string
};
var _default = exports["default"] = (0, _react.memo)(ToggleSwitch);